(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3446],{

/***/ 47020:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-estimate",
      function () {
        return __webpack_require__(77761);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ request_estimate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(91131);
;// CONCATENATED MODULE: ./src/state/steps.tsx

var stepOneArray = (0,esm/* atom */.cn)([]);
var stepTwoArray = (0,esm/* atom */.cn)([]);
var stepThreeArray = (0,esm/* atom */.cn)([]);
var stepFourArray = (0,esm/* atom */.cn)([]);
var stepFiveArray = (0,esm/* atom */.cn)([]);
var stepOneFirstItem = (0,esm/* atom */.cn)({
    label: "Validating my product idea",
    id: "productIdea",
    isChecked: false
});
var stepOneSecondItem = (0,esm/* atom */.cn)({
    label: "Creating an MVP",
    id: "createMVP",
    isChecked: false
});
var stepOneThirdItem = (0,esm/* atom */.cn)({
    label: "Scale an existing product",
    id: "scaleProduct",
    isChecked: false
});
var stepOneFourthItem = (0,esm/* atom */.cn)({
    label: "Driving more sales",
    id: "moreSales",
    isChecked: false
});
var stepOneFifthItem = (0,esm/* atom */.cn)({
    label: "Cutting costs",
    id: "cutCost",
    isChecked: false
});
var stepOneSixthItem = (0,esm/* atom */.cn)({
    label: "Other",
    id: "other",
    isChecked: false,
    others: ""
});
// step-------------------2
var stepTwoFirstItem = (0,esm/* atom */.cn)({
    label: "Product idea ideation & validation",
    id: "productIdeaIV",
    isChecked: false
});
var stepTwoSecondItem = (0,esm/* atom */.cn)({
    label: "UX / UI Design",
    id: "uiUx",
    isChecked: false
});
var stepTwoThirdItem = (0,esm/* atom */.cn)({
    label: "Software development",
    id: "softDev",
    isChecked: false
});
var stepTwoFourthItem = (0,esm/* atom */.cn)({
    label: "Cloud / DevOps",
    id: "cloudDev",
    isChecked: false
});
var stepTwoFifthItem = (0,esm/* atom */.cn)({
    label: "Data Science & Engineering / Machine Learning",
    id: "dseML",
    isChecked: false
});
var stepTwoSixthItem = (0,esm/* atom */.cn)({
    label: "Digital transformation / Process optimization",
    id: "dtPo",
    isChecked: false
});
// step three
var stepThreeFirstItem = (0,esm/* atom */.cn)({
    label: "ios",
    id: "ios",
    isChecked: false
});
var stepThreeSecondItem = (0,esm/* atom */.cn)({
    label: "Android",
    id: "android",
    isChecked: false
});
var stepThreeThirdItem = (0,esm/* atom */.cn)({
    label: "Kotlin",
    id: "kotlin",
    isChecked: false
});
var stepThreeFourthItem = (0,esm/* atom */.cn)({
    label: "React Native",
    id: "reactNative",
    isChecked: false
});
var stepThreeFiveItem = (0,esm/* atom */.cn)({
    label: "Flutter",
    id: "flutter",
    isChecked: false
});
var stepThreeSixItem = (0,esm/* atom */.cn)({
    label: "React",
    id: "react",
    isChecked: false
});
var stepThreeSevenItem = (0,esm/* atom */.cn)({
    label: "Angular",
    id: "angular",
    isChecked: false
});
var stepThreeEightItem = (0,esm/* atom */.cn)({
    label: "Vue",
    id: "vue",
    isChecked: false
});
var stepThreeNineItem = (0,esm/* atom */.cn)({
    label: "Ruby",
    id: "ruby",
    isChecked: false
});
var stepThreeTenItem = (0,esm/* atom */.cn)({
    label: "Node",
    id: "node",
    isChecked: false
});
var stepThreeElevenItem = (0,esm/* atom */.cn)({
    label: "Java",
    id: "java",
    isChecked: false
});
var stepThreeTwelveItem = (0,esm/* atom */.cn)({
    label: "PHP",
    id: "php",
    isChecked: false
});
var stepThreeThirtyItem = (0,esm/* atom */.cn)({
    label: "Machine Learning",
    id: "machineLearning",
    isChecked: false
});
var stepThreeFortyItem = (0,esm/* atom */.cn)({
    label: "Python",
    id: "python",
    isChecked: false
});
var stepThreeFiftyItem = (0,esm/* atom */.cn)({
    label: "Salesforce Development",
    id: "salesforceDevelopment",
    isChecked: false
});
var stepThreeSixtyItem = (0,esm/* atom */.cn)({
    label: "Quality Assurance",
    id: "qualityAssurance",
    isChecked: false
});
var stepThreeSeventyItem = (0,esm/* atom */.cn)({
    label: "Devops",
    id: "devops",
    isChecked: false
});
var stepThreeEightyItem = (0,esm/* atom */.cn)({
    label: "Other",
    id: "other",
    isChecked: false,
    others: ""
});
// Step four
var stepFourAboutProject = (0,esm/* atom */.cn)({
    label: "About Project",
    id: "aboutProject",
    value: ""
});
var stepFourTwoItem = (0,esm/* atom */.cn)({
    label: "Project budget",
    id: "projectBudget",
    value: ""
});
// step five 
var stepFiveFirstName = (0,esm/* atom */.cn)({
    label: "FirstName",
    id: "firstName",
    firstName: ""
});
var stepFiveLastName = (0,esm/* atom */.cn)({
    label: "LastName",
    id: "LastName",
    lastName: ""
});
var stepFiveEmail = (0,esm/* atom */.cn)({
    label: "Email",
    id: "email",
    email: ""
});
var stepFivePhone = (0,esm/* atom */.cn)({
    label: "Phone",
    id: "phone",
    phone: ""
});
var stepFiveCompanyName = (0,esm/* atom */.cn)({
    label: "Company Name",
    id: "company",
    companyName: ""
});
var stepFiveJobRole = (0,esm/* atom */.cn)({
    label: "Job Role",
    id: "job",
    jobRole: ""
});
var stepFiveNDA = (0,esm/* atom */.cn)({
    label: "NDA",
    id: "nda",
    isChecked: false,
    newNda: ""
});
var stepFiveCheck = (0,esm/* atom */.cn)({
    label: "Check",
    id: "check",
    isChecked: false
});

;// CONCATENATED MODULE: ./src/views/GetStarted/partials/StepsButton.tsx


var StepsButton = function(param) {
    var setSteps = param.setSteps, steps = param.steps, stepOneValues = param.stepOneValues, setStepOneError = param.setStepOneError, stepTwoValues = param.stepTwoValues, setStepTwoError = param.setStepTwoError, stepFourValues = param.stepFourValues, stepThreeValues = param.stepThreeValues, setStepThreeError = param.setStepThreeError, setStepFourError = param.setStepFourError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-max",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-2 items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        steps === 1 && !stepOneValues.length ? setStepOneError(true) : setSteps(1);
                    },
                    className: "w-4 h-4 rounded-[2px] ".concat(steps >= 1 ? "bg-primary" : "bg-gray-200", " hover:outline outline-[#1212122f] outline-2 outline-offset-0 focus:outline-none")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        steps === 1 && !stepOneValues.length ? setStepOneError(true) : setSteps(2);
                    },
                    className: "w-4 h-4 rounded-[2px] ".concat(steps >= 2 ? "bg-primary" : "bg-gray-200", " hover:outline outline-[#1212122f] outline-2 outline-offset-0 focus:outline-none")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        steps === 2 && !stepTwoValues.length ? setStepTwoError(true) : setSteps(3);
                    },
                    className: "w-4 h-4 rounded-[2px] ".concat(steps >= 3 ? "bg-primary" : "bg-gray-200", " hover:outline outline-[#1212122f] outline-2 outline-offset-0 focus:outline-none ").concat(steps === 1 && !stepThreeValues.length ? "cursor-not-allowed" : "cursor-pointer"),
                    disabled: steps === 1 && !stepThreeValues.length
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        steps === 3 && !stepThreeValues.length ? setStepThreeError(true) : setSteps(4);
                    },
                    className: "w-4 h-4 rounded-[2px] ".concat(steps >= 4 ? "bg-primary" : "bg-gray-200", " hover:outline outline-[#1212122f] outline-2 outline-offset-0 focus:outline-none ").concat((steps === 1 || steps === 2) && !stepFourValues.length ? "cursor-not-allowed" : "cursor-pointer"),
                    disabled: (steps === 1 || steps === 2) && !stepFourValues.length
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        steps === 4 && stepFourValues.length !== 2 ? setStepFourError(true) : setSteps(5);
                    },
                    className: "w-4 h-4 rounded-[2px] ".concat(steps >= 5 ? "bg-primary" : "bg-gray-200", " hover:outline outline-[#1212122f] outline-2 outline-offset-0 focus:outline-none ").concat(steps === 1 || steps === 2 || steps === 3 ? "cursor-not-allowed" : "cursor-pointer"),
                    disabled: steps === 1 || steps === 2 || steps === 3
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "ml-3 text-[#878787] text-sm font-semibold",
                    children: [
                        "STEP ",
                        steps,
                        " OF 5"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var partials_StepsButton = (StepsButton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/views/GetStarted/partials/Button.tsx


var Button = function(param) {
    var onClick = param.onClick, text = param.text, css = param.css, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: type ? type : null,
        className: "flex gap-4 items-center group relative contact-border duration-300 ease-in-out ".concat(css),
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "text-[13px] group-hover:pl-2 duration-300 font-bold font-primary text-redblack leading-4",
            children: text
        })
    });
};
/* harmony default export */ var partials_Button = (Button);

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@emailjs/browser/es/index.js + 7 modules
var browser_es = __webpack_require__(75247);
;// CONCATENATED MODULE: ./src/icons/InfoIcon.tsx


var InfoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.5 0A9.5 9.5 0 1 0 19 9.5 9.511 9.511 0 0 0 9.5 0zm1.188 4.156A1.188 1.188 0 1 1 9.5 5.344a1.187 1.187 0 0 1 1.188-1.188zm1.047 10.121a4.97 4.97 0 0 1-2.089.566 1.936 1.936 0 0 1-1.321-.414c-.62-.546-.516-1.335-.322-2.142l.584-2.068c.113-.426.341-1.3.021-1.6s-1.065-.112-1.5.049l.156-.637a6.1 6.1 0 0 1 2.092-.566c1.015 0 1.758.508 1.758 1.466q0 .134-.031.474a15.909 15.909 0 0 1-.7 2.684 5.214 5.214 0 0 0-.185 1.048c0 1 1.162.752 1.69.5z",
            fill: "#6D6E6D"
        })
    });
};
/* harmony default export */ var icons_InfoIcon = (InfoIcon);

;// CONCATENATED MODULE: ./src/icons/InfoIconActive.tsx


var InfoIconActive = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.5 0A9.5 9.5 0 1 0 19 9.5 9.511 9.511 0 0 0 9.5 0zm1.188 4.156A1.188 1.188 0 1 1 9.5 5.344a1.187 1.187 0 0 1 1.188-1.188zm1.047 10.121a4.97 4.97 0 0 1-2.089.566 1.936 1.936 0 0 1-1.321-.414c-.62-.546-.516-1.335-.322-2.142l.584-2.068c.113-.426.341-1.3.021-1.6s-1.065-.112-1.5.049l.156-.637a6.1 6.1 0 0 1 2.092-.566c1.015 0 1.758.508 1.758 1.466q0 .134-.031.474a15.909 15.909 0 0 1-.7 2.684 5.214 5.214 0 0 0-.185 1.048c0 1 1.162.752 1.69.5z",
            fill: "#4B4B4B"
        })
    });
};
/* harmony default export */ var icons_InfoIconActive = (InfoIconActive);

;// CONCATENATED MODULE: ./src/icons/BsBoxArrowUpIcon.tsx

var BsBoxArrowUpIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
            })
        ]
    });
};
/* harmony default export */ var icons_BsBoxArrowUpIcon = (BsBoxArrowUpIcon);

;// CONCATENATED MODULE: ./src/views/GetStarted/steps/StepFive.tsx















var FromSchema = es/* object */.Ry().shape({
    firstName: es/* string */.Z_().required("Required"),
    lastName: es/* string */.Z_().required("Required"),
    email: es/* string */.Z_().email("Enter valid email").required("Required")
});
var StepFive = function(param) {
    var setSuccess = param.setSuccess, setGetStarted = param.setGetStarted, setStepsError = param.setStepsError;
    var ref = (0,react.useState)(false), detailsActive = ref[0], setDetailsActive = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneArray), 2), stepOneData = ref1[0], setStepOneData = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoArray), 2), stepTwoData = ref2[0], setStepTwoData = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeArray), 2), stepThreeData = ref3[0], setStepThreeData = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFourArray), 2), stepFourData = ref4[0], setStepFourData = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveFirstName), 2), firstName = ref5[0], setFirstName = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveLastName), 2), lastName = ref6[0], setLastName = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveEmail), 2), email = ref7[0], setEmail = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFivePhone), 2), phone = ref8[0], setPhone = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveCompanyName), 2), companyName = ref9[0], setCompanyName = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveJobRole), 2), jobRole = ref10[0], setJobRole = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveNDA), 2), nda = ref11[0], setNDA = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveCheck), 2), check = ref12[0], setCheck = ref12[1];
    // states need to null for step one
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneFirstItem), 2), firstStepFirstItem = ref13[0], setFirstStepFirstItem = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneSecondItem), 2), firstStepSecondItem = ref14[0], setFirstStepSecondItem = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneThirdItem), 2), firstStepThirdItem = ref15[0], setFirstStepThirdItem = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneFourthItem), 2), firstStepFourthItem = ref16[0], setFirstStepFourthItem = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneFifthItem), 2), firstStepFifthItem = ref17[0], setFirstStepFifthItem = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneSixthItem), 2), firstStepSixthItem = ref18[0], setFirstStepSixthItem = ref18[1];
    // states need to null for step two
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoFirstItem), 2), secondStepFirstItem = ref19[0], setSecondStepFirstItem = ref19[1];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoSecondItem), 2), secondStepSecondItem = ref20[0], setSecondStepSecondItem = ref20[1];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoThirdItem), 2), secondStepThirdItem = ref21[0], setSecondStepThirdItem = ref21[1];
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoFourthItem), 2), secondStepFourthItem = ref22[0], seSecondtStepFourthItem = ref22[1];
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoFifthItem), 2), secondStepFifthItem = ref23[0], setSecondStepFifthItem = ref23[1];
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoSixthItem), 2), secondStepSixthItem = ref24[0], setSecondStepSixthItem = ref24[1];
    // states need to null for step three
    var ref25 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFirstItem), 2), threeFirstItem = ref25[0], setThreeFirstItem = ref25[1];
    var ref26 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSecondItem), 2), threeTwoItem = ref26[0], setThreeTwoItem = ref26[1];
    var ref27 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeThirdItem), 2), threeThreeItem = ref27[0], setThreeThreeItem = ref27[1];
    var ref28 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFourthItem), 2), threeFourItem = ref28[0], setThreeFourItem = ref28[1];
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFiveItem), 2), threeFifthItem = ref29[0], setThreeFifthItem = ref29[1];
    var ref30 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSixItem), 2), threeSixthItem = ref30[0], setThreeSixthItem = ref30[1];
    var ref31 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSevenItem), 2), threeSevenItem = ref31[0], setThreeSevenItem = ref31[1];
    var ref32 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeEightItem), 2), threeEightItem = ref32[0], setThreeEightItem = ref32[1];
    var ref33 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeNineItem), 2), threeNineItem = ref33[0], setThreeNineItem = ref33[1];
    var ref34 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeTenItem), 2), threeTenItem = ref34[0], setThreeTenItem = ref34[1];
    var ref35 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeElevenItem), 2), threeElevenItem = ref35[0], setThreeElevenItem = ref35[1];
    var ref36 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeTwelveItem), 2), threeTwelveItem = ref36[0], setThreeTwelveItem = ref36[1];
    var ref37 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeThirtyItem), 2), threeThirteenItem = ref37[0], setThreeThirteenItem = ref37[1];
    var ref38 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFortyItem), 2), threeFourthteenItem = ref38[0], setThreeFourtheenItem = ref38[1];
    var ref39 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFiftyItem), 2), threeFifthteenItem = ref39[0], setThreeFifthteenItem = ref39[1];
    var ref40 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSixtyItem), 2), threeSixtheenItem = ref40[0], setThreeSixthteenItem = ref40[1];
    var ref41 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSeventyItem), 2), threeSeventeenItem = ref41[0], setThreeSeventeenItem = ref41[1];
    var ref42 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeEightyItem), 2), threeEightteenItem = ref42[0], setThreeEightteenItem = ref42[1];
    // states need to null for step four
    var ref43 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFourAboutProject), 2), fourFirstItem = ref43[0], setFourFirstItem = ref43[1];
    var ref44 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFourTwoItem), 2), fourTwoItem = ref44[0], setFourTwoItem = ref44[1];
    // states need to null for step four
    var ref45 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveFirstName), 2), fiveFirstname = ref45[0], setFiveFirstname = ref45[1];
    var ref46 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveLastName), 2), fiveLastname = ref46[0], setFiveLastname = ref46[1];
    var ref47 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveEmail), 2), fiveEmail = ref47[0], setFiveEmail = ref47[1];
    var ref48 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFivePhone), 2), fivePhone = ref48[0], setFivePhone = ref48[1];
    var ref49 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveCompanyName), 2), fiveCompanyName = ref49[0], setFiveCompanyName = ref49[1];
    var ref50 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveJobRole), 2), fiveJobRole = ref50[0], setFiveJobROle = ref50[1];
    var ref51 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveNDA), 2), fiveDNA = ref51[0], setFiveDNA = ref51[1];
    var ref52 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFiveCheck), 2), fiveCheck = ref52[0], setFiveCheck = ref52[1];
    var handleSubmit = function(values, param) {
        var resetForm = param.resetForm;
        if (stepOneData.length === 0 || stepTwoData.length === 0 || stepThreeData.length === 0 || stepFourData.length === 0) {
            setStepsError(true);
            return;
        }
        var mainChallenge = [];
        var helpWith = [];
        var technologies = [];
        if (stepOneData.length) {
            stepOneData.map(function(item) {
                return item.id === "other" ? mainChallenge.push(item.others) : mainChallenge.push(item.label);
            });
        }
        if (stepTwoData.length) {
            stepTwoData.map(function(item) {
                return helpWith.push(item.label);
            });
        }
        if (stepThreeData.length) {
            stepThreeData.map(function(item) {
                return item.id === "other" ? technologies.push(item.others) : technologies.push(item.label);
            });
        }
        var formData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
            mainChallenge: mainChallenge,
            helpWith: helpWith,
            technologies: technologies
        });
        var content = "\n    <p>Request person details: </p>\n    <p>Name: ".concat(formData.firstName + " " + formData.lastName, "</p>\n    <p>Email: ").concat(formData.email, "</p>\n    <p>Phone Number: ").concat(formData.phone, "</p>\n    <p>Company Name: ").concat(formData.companyName, "</p>\n    <p>Job describe the best: ").concat(formData.jobRole, "</p>\n    <p>Is ").concat(formData.firstName + " " + formData.lastName, " need and NDA first: ").concat(formData.nda, "</p>\n\n    <br />\n\n    <h5>What are the main challenges ").concat(formData.firstName + " " + formData.lastName, " facing right now?</h5>\n    ").concat(formData.mainChallenge.map(function(item, index) {
            return "<p>".concat(index + 1, ": ").concat(item, "</p>");
        }), "\n\n    <br />\n\n    <h5>What can Digital Gregg help ").concat(formData.firstName + " " + formData.lastName, " with?</h5>\n    ").concat(formData.helpWith.map(function(item, index) {
            return "<p>".concat(index + 1, ": ").concat(item, "</p>");
        }), "\n\n    <br />\n\n    <h5>Are there any specific technologies or services that ").concat(formData.firstName + " " + formData.lastName, " is looking for?</h5>\n    ").concat(formData.technologies.map(function(item, index) {
            return "<p>".concat(index + 1, ": ").concat(item, "</p>");
        }), "\n\n    <br />\n\n    <h5>About ").concat(formData.firstName + " " + formData.lastName, " project</h5>\n    ").concat(stepFourData.map(function(item) {
            return "<p>".concat(item.label, ": ").concat(item.value, "</p>");
        }));
        var emailJsOptions = {
            from_name: "Digital Gregg",
            to_name: "".concat(values.email),
            content: content,
            // from_email: 'yourname@example.com',
            name: "".concat(values.firstName + " " + values.lastName)
        };
        browser_es/* default.send */.ZP.send("".concat("service_2zb60bk"), "".concat("template_ccl9g6d"), emailJsOptions, "".concat("nK-nPn7NrWsFx1mbV")).then(function(result) {
            if (result.status === 200) {
                resetForm();
                setSuccess(true);
                setGetStarted(false);
                setStepOneData([]);
                setStepTwoData([]);
                setStepThreeData([]);
                setStepFourData([]);
                // step one
                setFirstStepFirstItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, firstStepFirstItem), {
                    isChecked: false
                }));
                setFirstStepSecondItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, firstStepSecondItem), {
                    isChecked: false
                }));
                setFirstStepThirdItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, firstStepThirdItem), {
                    isChecked: false
                }));
                setFirstStepFourthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, firstStepFourthItem), {
                    isChecked: false
                }));
                setFirstStepFifthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, firstStepFifthItem), {
                    isChecked: false
                }));
                setFirstStepSixthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, firstStepSixthItem), {
                    isChecked: false,
                    others: ""
                }));
                // step two
                setSecondStepFirstItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, secondStepFirstItem), {
                    isChecked: false
                }));
                setSecondStepSecondItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, secondStepSecondItem), {
                    isChecked: false
                }));
                setSecondStepThirdItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, secondStepThirdItem), {
                    isChecked: false
                }));
                seSecondtStepFourthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, secondStepFourthItem), {
                    isChecked: false
                }));
                setSecondStepFifthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, secondStepFifthItem), {
                    isChecked: false
                }));
                setSecondStepSixthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, secondStepSixthItem), {
                    isChecked: false
                }));
                // step three 
                setThreeFirstItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeFirstItem), {
                    isChecked: false
                }));
                setThreeTwoItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeTwoItem), {
                    isChecked: false
                }));
                setThreeThreeItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeThreeItem), {
                    isChecked: false
                }));
                setThreeFourItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeFourItem), {
                    isChecked: false
                }));
                setThreeFifthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeFifthItem), {
                    isChecked: false
                }));
                setThreeSixthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeSixthItem), {
                    isChecked: false
                }));
                setThreeSevenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeSevenItem), {
                    isChecked: false
                }));
                setThreeEightItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeEightItem), {
                    isChecked: false
                }));
                setThreeNineItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeNineItem), {
                    isChecked: false
                }));
                setThreeTenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeTenItem), {
                    isChecked: false
                }));
                setThreeElevenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeElevenItem), {
                    isChecked: false
                }));
                setThreeTwelveItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeTwelveItem), {
                    isChecked: false
                }));
                setThreeThirteenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeThirteenItem), {
                    isChecked: false
                }));
                setThreeFourtheenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeFourthteenItem), {
                    isChecked: false
                }));
                setThreeFifthteenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeFifthteenItem), {
                    isChecked: false
                }));
                setThreeSixthteenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeSixtheenItem), {
                    isChecked: false
                }));
                setThreeSeventeenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeSeventeenItem), {
                    isChecked: false
                }));
                setThreeEightteenItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, threeEightteenItem), {
                    isChecked: false,
                    others: ""
                }));
                // step four
                setFourFirstItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fourFirstItem), {
                    value: ""
                }));
                setFourTwoItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fourTwoItem), {
                    value: ""
                }));
                // step five
                setFiveFirstname((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fiveFirstname), {
                    firstName: ""
                }));
                setFiveLastname((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fiveLastname), {
                    lastName: ""
                }));
                setFiveEmail((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fiveEmail), {
                    email: ""
                }));
                setFivePhone((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fivePhone), {
                    phone: ""
                }));
                setFiveCompanyName((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fiveCompanyName), {
                    companyName: ""
                }));
                setFiveJobROle((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fiveJobRole), {
                    jobRole: ""
                }));
                setFiveDNA((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fiveDNA), {
                    isChecked: false,
                    newNda: ""
                }));
                setFiveCheck((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fiveCheck), {
                    isChecked: false
                }));
            }
        }, function(error) {
            if (error) {
                console.log(error);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold text-black text-[26px] lg:text-[30px]",
                        children: "Great! You're almost there"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-medium text-[16px] my-8",
                        children: "Leave your details so we can contact you about your estimation."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                enableReinitialize: true,
                initialValues: {
                    firstName: firstName.firstName,
                    lastName: lastName.lastName,
                    email: email.email,
                    phone: phone.phone,
                    companyName: companyName.companyName,
                    jobRole: jobRole.jobRole,
                    nda: nda.newNda
                },
                validationSchema: FromSchema,
                onSubmit: handleSubmit,
                children: function(param) {
                    var errors = param.errors, touched = param.touched;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 gap-5 mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "text-black font-bold text-[14px]",
                                                children: "First Name *"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                type: "text",
                                                name: "firstName",
                                                placeholder: "Enter First Name",
                                                required: true,
                                                value: firstName.firstName,
                                                onChange: function(e) {
                                                    return setFirstName((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, firstName), {
                                                        firstName: e.target.value
                                                    }));
                                                },
                                                autoComplete: "none",
                                                className: "w-full ".concat(errors.firstName && touched.firstName && "border-primary", " h-12 rounded-lg pl-4 mt-2 focus:outline-none focus:border-primary border")
                                            }),
                                            errors.firstName && touched.firstName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-xs text-primary pt-1 font-medium",
                                                children: "Please complete this required field."
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "text-black font-bold text-[14px]",
                                                children: "Last Name *"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                type: "text",
                                                name: "lastName",
                                                placeholder: "Enter Last Name",
                                                required: true,
                                                value: lastName.lastName,
                                                onChange: function(e) {
                                                    return setLastName((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, lastName), {
                                                        lastName: e.target.value
                                                    }));
                                                },
                                                autoComplete: "none",
                                                className: "w-full ".concat(errors.lastName && touched.lastName && "border-primary", " h-12 rounded-lg pl-4 mt-2 focus:outline-none focus:border-primary border")
                                            }),
                                            errors.lastName && touched.lastName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-xs text-primary pt-1 font-medium",
                                                children: "Please complete this required field."
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-5 mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "text-black font-bold text-[14px]",
                                                children: "Email *"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                type: "text",
                                                name: "email",
                                                placeholder: "Enter Email Address",
                                                required: true,
                                                value: email.email,
                                                onChange: function(e) {
                                                    return setEmail((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, email), {
                                                        email: e.target.value
                                                    }));
                                                },
                                                autoComplete: "none",
                                                className: "w-full ".concat(errors.email && touched.email && "border-primary", " h-12 rounded-lg pl-4 mt-2 focus:outline-none focus:border-primary border")
                                            }),
                                            errors.email && touched.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-xs text-primary pt-1 font-medium",
                                                children: "Please complete this required field."
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "text-black font-bold text-[14px]",
                                                children: "Phone Number"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                type: "number",
                                                name: "phone",
                                                placeholder: "Enter Phone Number",
                                                required: true,
                                                value: phone.phone,
                                                onChange: function(e) {
                                                    return setPhone((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, phone), {
                                                        phone: e.target.value
                                                    }));
                                                },
                                                autoComplete: "none",
                                                className: "w-full h-12 rounded-lg pl-4 mt-2 focus:outline-none focus:border-primary border"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-5 mb-6 items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "text-black font-bold text-[14px]",
                                                children: "Company Name"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                type: "text",
                                                name: "companyName",
                                                placeholder: "Enter Company Name",
                                                required: true,
                                                value: companyName.companyName,
                                                onChange: function(e) {
                                                    return setCompanyName((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, companyName), {
                                                        companyName: e.target.value
                                                    }));
                                                },
                                                autoComplete: "none",
                                                className: "w-full h-12 rounded-lg pl-4 mt-2 focus:outline-none focus:border-primary border"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "text-black font-bold text-[14px]",
                                                children: "What job role describes you the best?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Field */.gN, {
                                                    as: "select",
                                                    name: "jobRole",
                                                    required: true,
                                                    value: jobRole.jobRole,
                                                    onChange: function(e) {
                                                        return setJobRole((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jobRole), {
                                                            jobRole: e.target.value
                                                        }));
                                                    },
                                                    className: "h-12 w-full overflow-hidden rounded-lg pl-4 pr-4 mt-2 focus:outline-none focus:ring-1 ring-primary font-medium appearance-none custom-select",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "",
                                                            children: "Select Option"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "Founder/C-level Executive",
                                                            children: "Founder / C-level Executive"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "Department Director/Product Director",
                                                            children: "Department Director/Product Director"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "Manager/Team Leader",
                                                            children: "Manager/Team Leader"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "Other",
                                                            children: "Other"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "text-black font-bold text-[14px] mb-3 block",
                                            children: "Do you need an NDA first?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "bg-white rounded mr-3 group",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "group-hover:text-primary flex items-center px-3 py-2 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                type: "radio",
                                                                name: "nda",
                                                                required: true,
                                                                value: "Yes",
                                                                checked: "Yes" === nda.newNda,
                                                                onChange: function(e) {
                                                                    return setNDA((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nda), {
                                                                        newNda: e.target.value
                                                                    }));
                                                                },
                                                                className: "w-5 h-5 transition-all ease-linear duration-200"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "pl-2 font-medium group-hover:text-primary transition-all ease-linear duration-200",
                                                                children: "Yes"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "bg-white rounded mr-3 group",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "group-hover:text-primary flex items-center px-3 py-2 cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                type: "radio",
                                                                name: "nda",
                                                                required: true,
                                                                value: "No",
                                                                checked: "No" === nda.newNda,
                                                                onChange: function(e) {
                                                                    return setNDA((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nda), {
                                                                        newNda: e.target.value
                                                                    }));
                                                                },
                                                                className: "w-5 h-5 transition-all ease-linear duration-200"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "pl-2 font-medium group-hover:text-primary transition-all ease-linear duration-200",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-6 relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: "custom-checkbox rounded-[0.6rem] group checkbox block relative top-0 pl-[35px] mt-[2px] cursor-pointer text-[12px] font-medium transition-all ease-linear duration-300",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                        type: "checkbox",
                                                        name: "check",
                                                        checked: check.isChecked,
                                                        onChange: function(e) {
                                                            return setCheck((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, check), {
                                                                isChecked: !check.isChecked
                                                            }));
                                                        },
                                                        autoComplete: "none",
                                                        className: "absolute opacity-[0] cursor-pointer h-0 w-0"
                                                    }),
                                                    "I agree to receive marketing communication from Digital Gregg.",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "checkmark absolute top-1/2 translate-y-[-50%] left-0 h-[20px] w-[20px] ".concat(check.isChecked ? "!bg-primary !border-primary" : "bg-white", " border after:content-[''] group-hover:border-primary after:absolute after:hidden after:left-[6px] after:top-[1.4px] after:w-[7px] after:h-[12px] after:border-[#FFF] after:border-[0_2.5px_2.5px_0] transition-all ease-linear duration-300")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return setDetailsActive(!detailsActive);
                                                },
                                                className: "inline-block text-xl cursor-pointer transition-all ease-linear duration-200 ml-2",
                                                children: !detailsActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_InfoIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_InfoIconActive, {})
                                            })
                                        ]
                                    }),
                                    detailsActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute bottom-[50px] md:bottom-[40px] w-full sm:w-[458px] md:w-[550px] privacy-check-arrow mobilePrivacyArrow left-0 lg:left-auto md:-right-[40px] lg:-right-[50px] border bg-white px-5 py-8 rounded-md",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-privacy text-[12px] font-semibold leading-6",
                                                children: [
                                                    "Digital Gregg is committed to processing the above information in order to contact you and talk about your project. Other information is used for statistical purposes and, from time to time, we would like to contact you about our other products and services, as well as other content that may be of interest to you. If you consent to contact you for these purposes, please tick the checkbox below.",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[12px] text-privacy mt-4 font-semibold leading-6",
                                                children: [
                                                    "You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices please view our",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/privacy-policy",
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "#",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            "aria-label": "privacy policy page",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "cursor-pointer underline hover:text-primary",
                                                                children: [
                                                                    "Privacy Policy",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "inline-block ml-2 font-bold",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_BsBoxArrowUpIcon, {})
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return setDetailsActive(false);
                                                },
                                                className: "text-primary hover:opacity-80 transition-all duration-300 font-bold text-lg mt-5",
                                                children: "Ok, got it"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Button, {
                                    text: "Request Free Estimate",
                                    css: "mt-14",
                                    type: "submit"
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var steps_StepFive = (StepFive);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/views/GetStarted/partials/TextArea.tsx


var TextArea = function(param) {
    var value = param.value, onChange = param.onChange, error = param.error, placeholder = param.placeholder;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-5 mt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
            className: "form-control block w-full px-3  py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white ".concat(error ? "!border-primary" : null, " focus:border-primary resize-none"),
            rows: 7,
            placeholder: placeholder,
            value: value,
            onChange: onChange
        })
    });
};
/* harmony default export */ var partials_TextArea = (TextArea);

;// CONCATENATED MODULE: ./src/views/GetStarted/steps/StepFour.tsx










var StepFour = function(param) {
    var data = param.data, setData = param.setData, setSteps = param.setSteps, stepFourError = param.stepFourError, setStepFourError = param.setStepFourError;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFourAboutProject), 2), aboutProject = ref[0], setAboutProject = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFourTwoItem), 2), projectBudget = ref1[0], setProjectBudget = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-[600px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "font-bold text-black text-[26px] lg:text-[30px]",
                children: "Tell us more about your project"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "text-black font-semibold text-[15px]",
                        children: "Project budget"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "number",
                        name: "phone",
                        value: projectBudget.value,
                        onKeyDown: function(evt) {
                            return [
                                "e",
                                "E",
                                "+",
                                "-"
                            ].includes(evt.key) && evt.preventDefault();
                        },
                        onChange: function(e) {
                            setProjectBudget((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, projectBudget), {
                                value: e.target.value
                            }));
                            setData((0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                                return item.id !== projectBudget.id;
                            })).concat([
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, projectBudget), {
                                    value: e.target.value
                                }), 
                            ]));
                        },
                        placeholder: "Enter your budget in number",
                        autoComplete: "none",
                        className: "w-full h-12 rounded-lg pl-4 mt-2 focus:outline-none ".concat(stepFourError ? "border-primary" : null, " focus:border-primary border")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-black font-semibold mt-5 text-[15px] !-mb-5",
                children: "Description"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_TextArea, {
                value: aboutProject.value,
                error: stepFourError,
                placeholder: "Describe about the project",
                onChange: function(e) {
                    setAboutProject((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, aboutProject), {
                        value: e.target.value
                    }));
                    setData((0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                        return item.id !== aboutProject.id;
                    })).concat([
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, aboutProject), {
                            value: e.target.value
                        }), 
                    ]));
                }
            }),
            stepFourError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-primary font-medium text-sm cursor-default",
                children: "Please complete this required field."
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "my-3 font-medium text-[16px]",
                        children: "Our customers most often write to us about:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        className: "marker:text-primary font-medium list-disc pl-5 space-y-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "text-[16px] leading-[20px]",
                                children: "Details of the project"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "text-[16px] leading-[20px]",
                                children: "The business goals"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "text-[16px] leading-[20px]",
                                children: "If the design is ready"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "text-[16px] leading-[20px]",
                                children: "If the project is new or ongoing"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "text-[16px] leading-[20px]",
                                children: "The deadline"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Button, {
                text: "Continue",
                css: "mt-14",
                onClick: function() {
                    if (data.length === 2) {
                        var ref, ref1;
                        if (((ref = data[0]) === null || ref === void 0 ? void 0 : ref.value) === "" || ((ref1 = data[1]) === null || ref1 === void 0 ? void 0 : ref1.value) === "") {
                            setStepFourError(true);
                        } else {
                            setSteps(5);
                        }
                    } else {
                        setStepFourError(true);
                    }
                }
            })
        ]
    });
};
/* harmony default export */ var steps_StepFour = (StepFour);

;// CONCATENATED MODULE: ./src/views/GetStarted/partials/Checkmark.tsx

var Checkmark = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 11 11",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M10.9362 1.20996L4.12692 10.1692L-0.000244141 6.04201L1.41397 4.62779L3.92102 7.13484L9.34392 -0.000244141L10.9362 1.20996Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var partials_Checkmark = (Checkmark);

;// CONCATENATED MODULE: ./src/views/GetStarted/partials/Checkbox.tsx





var Checkbox = function(param) {
    var label = param.label, id = param.id, itemData = param.itemData, isChecked = param.isChecked, setIsChecked = param.setIsChecked, setData = param.setData, data = param.data, error = param.error;
    // checkbox checked to send item to main state
    var handleChange = function(e) {
        if (e.target.checked) {
            if (!(data === null || data === void 0 ? void 0 : data.find(function(item) {
                return item.id === itemData.id;
            }))) {
                setData((0,_to_consumable_array/* default */.Z)(data).concat([
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemData), {
                        isChecked: true
                    })
                ]));
            }
        } else {
            setData(data === null || data === void 0 ? void 0 : data.filter(function(item) {
                return item.id !== itemData.id;
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full md:w-max",
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            htmlFor: id,
            className: "custom-checkbox rounded-[0.6rem] group bg-[#FFF] checkbox p-[.7em_1em] block relative top-0 pl-[44px] mt-[1px] cursor-pointer text-base font-medium hover:text-primary transition-all ease-linear duration-300 text-[16px]",
            children: [
                label,
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "checkbox",
                    id: id,
                    className: "absolute opacity-[0] cursor-pointer h-0 w-0",
                    checked: isChecked,
                    onChange: function(e) {
                        handleChange(e);
                        setIsChecked((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemData), {
                            isChecked: !isChecked
                        }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "absolute text-center flex  justify-center items-center top-1/2 translate-y-[-50%] left-3 h-[20px] w-[20px] border-[1px] border-[#ccc] group-hover:border-primary transition-all duration-300 ".concat(isChecked && "bg-primary border-none"),
                    children: isChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkmark, {})
                })
            ]
        })
    });
};
/* harmony default export */ var partials_Checkbox = (Checkbox);

;// CONCATENATED MODULE: ./src/views/GetStarted/partials/Error.tsx


var Error = function(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "text-primary font-medium text-sm cursor-default",
            children: "Please select at least one option."
        }) : null
    });
};
/* harmony default export */ var partials_Error = (Error);

;// CONCATENATED MODULE: ./src/views/GetStarted/steps/StepOne.tsx











var StepOne = function(param) {
    var data = param.data, setData = param.setData, setSteps = param.setSteps, stepOneError = param.stepOneError, setStepOneError = param.setStepOneError;
    // atom states
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneFirstItem), 2), firstItem = ref[0], setFirstItem = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneSecondItem), 2), secondItem = ref1[0], setSecondItem = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneThirdItem), 2), thirdItem = ref2[0], setThirdItem = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneFourthItem), 2), fourthItem = ref3[0], setFourthItem = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneFifthItem), 2), fifthItem = ref4[0], setFifthItem = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneSixthItem), 2), sixthItem = ref5[0], setSixthItem = ref5[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-[550px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "font-bold text-black text-[26px] lg:text-[30px]",
                children: "What are the main challenges you’re facing right now?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-5 mb-5 mt-11",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: firstItem.label,
                        id: firstItem.id,
                        data: data,
                        setData: setData,
                        itemData: firstItem,
                        isChecked: firstItem.isChecked,
                        setIsChecked: setFirstItem,
                        error: stepOneError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: secondItem.label,
                        id: secondItem.id,
                        data: data,
                        setData: setData,
                        itemData: secondItem,
                        isChecked: secondItem.isChecked,
                        setIsChecked: setSecondItem,
                        error: stepOneError
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-5 mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: thirdItem.label,
                        id: thirdItem.id,
                        data: data,
                        setData: setData,
                        itemData: thirdItem,
                        isChecked: thirdItem.isChecked,
                        setIsChecked: setThirdItem,
                        error: stepOneError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: fourthItem.label,
                        id: fourthItem.id,
                        data: data,
                        setData: setData,
                        itemData: fourthItem,
                        isChecked: fourthItem.isChecked,
                        setIsChecked: setFourthItem,
                        error: stepOneError
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-5 mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: fifthItem.label,
                        id: fifthItem.id,
                        data: data,
                        setData: setData,
                        itemData: fifthItem,
                        isChecked: fifthItem.isChecked,
                        setIsChecked: setFifthItem,
                        error: stepOneError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: sixthItem.label,
                        id: sixthItem.id,
                        data: data,
                        setData: setData,
                        itemData: sixthItem,
                        isChecked: sixthItem.isChecked,
                        setIsChecked: setSixthItem,
                        error: stepOneError
                    })
                ]
            }),
            sixthItem.isChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_TextArea, {
                error: stepOneError,
                value: sixthItem.others,
                placeholder: "Describe challenges that you are facing",
                onChange: function(e) {
                    setSixthItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sixthItem), {
                        others: e.target.value
                    }));
                    setData((0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                        return item.id !== sixthItem.id;
                    })).concat([
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sixthItem), {
                            others: e.target.value
                        }), 
                    ]));
                }
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Error, {
                error: stepOneError
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Button, {
                text: "Continue",
                css: "mt-14",
                onClick: function() {
                    if (!data.length) {
                        setStepOneError(true);
                    } else {
                        setSteps(2);
                    }
                }
            })
        ]
    });
};
/* harmony default export */ var steps_StepOne = (StepOne);

;// CONCATENATED MODULE: ./src/views/GetStarted/steps/StepThree.tsx












var StepThree = function(param) {
    var data = param.data, setData = param.setData, setSteps = param.setSteps, stepThreeError = param.stepThreeError, setStepThreeError = param.setStepThreeError;
    // atom states
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFirstItem), 2), firstItem = ref[0], setFirstItem = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSecondItem), 2), secondItem = ref1[0], setSecondItem = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeThirdItem), 2), thirdItem = ref2[0], setThirdItem = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFourthItem), 2), fourthItem = ref3[0], setFourthItem = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFiveItem), 2), fifthItem = ref4[0], setFifthItem = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSixItem), 2), sixItem = ref5[0], setSixItem = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSevenItem), 2), sevenItem = ref6[0], setSevenItem = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeEightItem), 2), eightItem = ref7[0], setEightItem = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeNineItem), 2), nineItem = ref8[0], setNineItem = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeTenItem), 2), tenItem = ref9[0], setTenItem = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeElevenItem), 2), elevenItem = ref10[0], setElevenItem = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeTwelveItem), 2), twelveItem = ref11[0], setTwelveItem = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeThirtyItem), 2), thirtyItem = ref12[0], setThirtyItem = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFortyItem), 2), fortyItem = ref13[0], setFortyItem = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeFiftyItem), 2), fiftyItem = ref14[0], setFiftyItem = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSixtyItem), 2), sixtyItem = ref15[0], setSixtyItem = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeSeventyItem), 2), seventyItem = ref16[0], setSeventyItem = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeEightyItem), 2), eightyItem = ref17[0], setEightyItem = ref17[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-[630px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "font-bold text-black text-[26px] lg:text-[30px] !leading-[40px]",
                    children: "Are there any specific technologies or services that you’re looking for?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap gap-3 mb-3 mt-11",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: firstItem.label,
                            id: firstItem.id,
                            data: data,
                            setData: setData,
                            itemData: firstItem,
                            isChecked: firstItem.isChecked,
                            setIsChecked: setFirstItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: secondItem.label,
                            id: secondItem.id,
                            data: data,
                            setData: setData,
                            itemData: secondItem,
                            isChecked: secondItem.isChecked,
                            setIsChecked: setSecondItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: thirdItem.label,
                            id: thirdItem.id,
                            data: data,
                            setData: setData,
                            itemData: thirdItem,
                            isChecked: thirdItem.isChecked,
                            setIsChecked: setThirdItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: fourthItem.label,
                            id: fourthItem.id,
                            data: data,
                            setData: setData,
                            itemData: fourthItem,
                            isChecked: fourthItem.isChecked,
                            setIsChecked: setFourthItem,
                            error: stepThreeError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap gap-3 mb-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: fifthItem.label,
                            id: fifthItem.id,
                            data: data,
                            setData: setData,
                            itemData: fifthItem,
                            isChecked: fifthItem.isChecked,
                            setIsChecked: setFifthItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: sixItem.label,
                            id: sixItem.id,
                            data: data,
                            setData: setData,
                            itemData: sixItem,
                            isChecked: sixItem.isChecked,
                            setIsChecked: setSixItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: sevenItem.label,
                            id: sevenItem.id,
                            data: data,
                            setData: setData,
                            itemData: sevenItem,
                            isChecked: sevenItem.isChecked,
                            setIsChecked: setSevenItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: eightItem.label,
                            id: eightItem.id,
                            data: data,
                            setData: setData,
                            itemData: eightItem,
                            isChecked: eightItem.isChecked,
                            setIsChecked: setEightItem,
                            error: stepThreeError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap gap-3 mb-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: nineItem.label,
                            id: nineItem.id,
                            data: data,
                            setData: setData,
                            itemData: nineItem,
                            isChecked: nineItem.isChecked,
                            setIsChecked: setNineItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: tenItem.label,
                            id: tenItem.id,
                            data: data,
                            setData: setData,
                            itemData: tenItem,
                            isChecked: tenItem.isChecked,
                            setIsChecked: setTenItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: elevenItem.label,
                            id: elevenItem.id,
                            data: data,
                            setData: setData,
                            itemData: elevenItem,
                            isChecked: elevenItem.isChecked,
                            setIsChecked: setElevenItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: twelveItem.label,
                            id: twelveItem.id,
                            data: data,
                            setData: setData,
                            itemData: twelveItem,
                            isChecked: twelveItem.isChecked,
                            setIsChecked: setTwelveItem,
                            error: stepThreeError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap gap-3 mb-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: thirtyItem.label,
                            id: thirtyItem.id,
                            data: data,
                            setData: setData,
                            itemData: thirtyItem,
                            isChecked: thirtyItem.isChecked,
                            setIsChecked: setThirtyItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: fortyItem.label,
                            id: fortyItem.id,
                            data: data,
                            setData: setData,
                            itemData: fortyItem,
                            isChecked: fortyItem.isChecked,
                            setIsChecked: setFortyItem,
                            error: stepThreeError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap gap-3 mb-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: fiftyItem.label,
                            id: fiftyItem.id,
                            data: data,
                            setData: setData,
                            itemData: fiftyItem,
                            isChecked: fiftyItem.isChecked,
                            setIsChecked: setFiftyItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: sixtyItem.label,
                            id: sixtyItem.id,
                            data: data,
                            setData: setData,
                            itemData: sixtyItem,
                            isChecked: sixtyItem.isChecked,
                            setIsChecked: setSixtyItem,
                            error: stepThreeError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap gap-3 mb-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: seventyItem.label,
                            id: seventyItem.id,
                            data: data,
                            setData: setData,
                            itemData: seventyItem,
                            isChecked: seventyItem.isChecked,
                            setIsChecked: setSeventyItem,
                            error: stepThreeError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                            label: eightyItem.label,
                            id: eightyItem.id,
                            data: data,
                            setData: setData,
                            itemData: eightyItem,
                            isChecked: eightyItem.isChecked,
                            setIsChecked: setEightyItem,
                            error: stepThreeError
                        })
                    ]
                }),
                eightyItem.isChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_TextArea, {
                    error: stepThreeError,
                    value: eightyItem.others,
                    placeholder: "Write down your technology / services",
                    onChange: function(e) {
                        setEightyItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eightyItem), {
                            others: e.target.value
                        }));
                        setData((0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                            return item.id !== eightyItem.id;
                        })).concat([
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eightyItem), {
                                others: e.target.value
                            }), 
                        ]));
                    }
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Error, {
                    error: stepThreeError
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Button, {
                    text: "Continue",
                    css: "mt-14",
                    onClick: function() {
                        if (!data.length) {
                            setStepThreeError(true);
                        } else {
                            setSteps(4);
                        }
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var steps_StepThree = (StepThree);

;// CONCATENATED MODULE: ./src/views/GetStarted/steps/StepTwo.tsx








var StepTwo = function(param) {
    var data = param.data, setData = param.setData, setSteps = param.setSteps, stepError = param.stepError, setStepError = param.setStepError;
    // atom states
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoFirstItem), 2), firstItem = ref[0], setFirstItem = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoSecondItem), 2), secondItem = ref1[0], setSecondItem = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoThirdItem), 2), thirdItem = ref2[0], setThirdItem = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoFourthItem), 2), fourthItem = ref3[0], setFourthItem = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoFifthItem), 2), fifthItem = ref4[0], setFifthItem = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoSixthItem), 2), sixthItem = ref5[0], setSixthItem = ref5[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "font-bold text-black text-[26px] lg:text-[30px]",
                children: "What can we help you with?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-5 mb-5 mt-11",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: firstItem.label,
                        id: firstItem.id,
                        data: data,
                        setData: setData,
                        itemData: firstItem,
                        isChecked: firstItem.isChecked,
                        setIsChecked: setFirstItem,
                        error: stepError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: secondItem.label,
                        id: secondItem.id,
                        data: data,
                        setData: setData,
                        itemData: secondItem,
                        isChecked: secondItem.isChecked,
                        setIsChecked: setSecondItem,
                        error: stepError
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-5 mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: thirdItem.label,
                        id: thirdItem.id,
                        data: data,
                        setData: setData,
                        itemData: thirdItem,
                        isChecked: thirdItem.isChecked,
                        setIsChecked: setThirdItem,
                        error: stepError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                        label: fourthItem.label,
                        id: fourthItem.id,
                        data: data,
                        setData: setData,
                        itemData: fourthItem,
                        isChecked: fourthItem.isChecked,
                        setIsChecked: setFourthItem,
                        error: stepError
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                    label: fifthItem.label,
                    id: fifthItem.id,
                    data: data,
                    setData: setData,
                    itemData: fifthItem,
                    isChecked: fifthItem.isChecked,
                    setIsChecked: setFifthItem,
                    error: stepError
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Checkbox, {
                    label: sixthItem.label,
                    id: sixthItem.id,
                    data: data,
                    setData: setData,
                    itemData: sixthItem,
                    isChecked: sixthItem.isChecked,
                    setIsChecked: setSixthItem,
                    error: stepError
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Error, {
                error: stepError
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Button, {
                text: "Continue",
                css: "mt-14",
                onClick: function() {
                    if (!data.length) {
                        setStepError(true);
                    } else {
                        setSteps(3);
                    }
                }
            })
        ]
    });
};
/* harmony default export */ var steps_StepTwo = (StepTwo);

;// CONCATENATED MODULE: ./src/components/Icons/BackArrow.tsx


var BackArrow = function(param) {
    var hoverColor = param.hoverColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "60",
        height: "8",
        viewBox: "0 0 60 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.64645 3.64645C0.451187 3.84171 0.451187 4.1583 0.64645 4.35356L3.82843 7.53554C4.02369 7.7308 4.34028 7.7308 4.53554 7.53554C4.7308 7.34028 4.7308 7.02369 4.53554 6.82843L1.70711 4.00001L4.53554 1.17158C4.7308 0.976316 4.7308 0.659733 4.53554 0.464471C4.34027 0.269209 4.02369 0.269209 3.82843 0.464471L0.64645 3.64645ZM60 3.5L1 3.50001L1 4.50001L60 4.5L60 3.5Z",
            fill: hoverColor
        })
    });
};
/* harmony default export */ var Icons_BackArrow = (BackArrow);

;// CONCATENATED MODULE: ./src/views/GetStarted/components/StepBack.tsx



var StepBack = function(param) {
    var setStep = param.setStep, backStepNum = param.backStepNum;
    var ref = (0,react.useState)("#C6C6C6"), color = ref[0], setColor = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onMouseOver: function() {
                return setColor("#C10206");
            },
            onMouseLeave: function() {
                return setColor("#C6C6C6");
            },
            onClick: function() {
                return setStep(backStepNum);
            },
            className: "flex items-center gap-4 group",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BackArrow, {
                    hoverColor: color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-[13px] font-semibold text-[#C6C6C6] group-hover:text-primary",
                    children: "Go Back"
                })
            ]
        })
    });
};
/* harmony default export */ var components_StepBack = (StepBack);

// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
;// CONCATENATED MODULE: ./src/views/GetStarted/components/StepsRight.tsx



var StepsRight = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-14 2xl:max-w-[25rem]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-center text-[14px] font-bold text-[#878787] mb-12 uppercase",
                children: "Join the global innovators"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-2 bg-white gap-y-16 rounded-lg",
                children: constant/* brandImagesSteps.map */.o5.map(function(imageUrl, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "flex justify-center items-center",
                        children: imageUrl.src
                    }, "bsihdnh_" + i);
                })
            })
        ]
    });
};
/* harmony default export */ var components_StepsRight = (StepsRight);

;// CONCATENATED MODULE: ./src/views/GetStarted/components/Steps.tsx













var Steps = function(param) {
    var setSuccess = param.setSuccess, setGetStarted = param.setGetStarted;
    // states
    var ref = (0,react.useState)(1), steps = ref[0], setSteps = ref[1];
    var ref1 = (0,react.useState)(false), stepsError = ref1[0], setStepsError = ref1[1];
    // step --------- 1
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepOneArray), 2), stepOneValues = ref2[0], setStepOneValues = ref2[1];
    var ref3 = (0,react.useState)(false), stepOneError = ref3[0], setStepOneError = ref3[1];
    // step --------- 2
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepTwoArray), 2), stepTwoValues = ref4[0], setStepTwoValues = ref4[1];
    var ref5 = (0,react.useState)(false), stepTwoError = ref5[0], setStepTwoError = ref5[1];
    // Step three
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepThreeArray), 2), stepThreeValues = ref6[0], setStepThreeValues = ref6[1];
    var ref7 = (0,react.useState)(false), stepThreeError = ref7[0], setStepThreeError = ref7[1];
    // Step four
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(stepFourArray), 2), stepFourValues = ref8[0], setStepFourValues = ref8[1];
    var ref9 = (0,react.useState)(false), stepFourError = ref9[0], setStepFourError = ref9[1];
    // seterror
    (0,react.useEffect)(function() {
        if (stepOneValues.length) {
            setStepOneError(false);
        }
        if (stepTwoValues.length) {
            setStepTwoError(false);
        }
        if (stepThreeValues.length) {
            setStepThreeError(false);
        }
        if (stepFourValues.length) {
            setStepFourError(false);
        }
    }, [
        stepOneValues.length,
        stepTwoValues.length,
        stepThreeValues.length,
        stepFourValues.length, 
    ]);
    // useEffect(() => {
    //   if (stepsError) {
    //     if (stepOneValues.length === 0) {
    //       setStepOneError(true);
    //     }
    //     if (stepTwoValues.length === 0) {
    //       setStepTwoError(true);
    //     }
    //     if (stepThreeValues.length === 0) {
    //       setStepThreeError(true);
    //     }
    //     if (stepFourValues.length === 0) {
    //       setStepFourError(true);
    //     }
    //     if (stepOneValues.length !== 0 && stepTwoValues.length !== 0 && stepThreeValues.length !== 0 && stepFourValues.length !== 0) {
    //       setStepsError(false);
    //     }
    //   }
    // }, [stepOneValues, stepTwoValues, stepThreeValues, stepFourValues, stepsError]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-0 md:px-5 lg:px-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pl-8 md:pl-0 lg:static absolute top-[25px] right-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_StepsButton, {
                    steps: steps,
                    setSteps: setSteps,
                    stepOneValues: stepOneValues,
                    stepTwoValues: stepTwoValues,
                    stepThreeValues: stepThreeValues,
                    stepFourValues: stepFourValues,
                    setStepOneError: setStepOneError,
                    setStepTwoError: setStepTwoError,
                    setStepThreeError: setStepThreeError,
                    setStepFourError: setStepFourError
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-10 grid xl:grid-cols-3 gap-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-3 xl:col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-8 lg:px-0 py-16 rounded-lg bg-[#F8F4F4] w-full h-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col justify-center items-center",
                                    children: [
                                        steps === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(steps_StepOne, {
                                            data: stepOneValues,
                                            setData: setStepOneValues,
                                            setSteps: setSteps,
                                            stepOneError: stepOneError,
                                            setStepOneError: setStepOneError
                                        }),
                                        steps === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(steps_StepTwo, {
                                            data: stepTwoValues,
                                            setData: setStepTwoValues,
                                            setSteps: setSteps,
                                            stepError: stepTwoError,
                                            setStepError: setStepTwoError
                                        }),
                                        steps === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(steps_StepThree, {
                                            data: stepThreeValues,
                                            setData: setStepThreeValues,
                                            setSteps: setSteps,
                                            stepThreeError: stepThreeError,
                                            setStepThreeError: setStepThreeError
                                        }),
                                        steps === 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(steps_StepFour, {
                                            data: stepFourValues,
                                            setData: setStepFourValues,
                                            setSteps: setSteps,
                                            stepFourError: stepFourError,
                                            setStepFourError: setStepFourError
                                        }),
                                        steps === 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(steps_StepFive, {
                                            setSuccess: setSuccess,
                                            setGetStarted: setGetStarted,
                                            setStepsError: setStepsError
                                        })
                                    ]
                                })
                            }),
                            steps > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StepBack, {
                                setStep: setSteps,
                                backStepNum: steps - 1
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-3 xl:col-span-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StepsRight, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Steps = (Steps);

;// CONCATENATED MODULE: ./src/views/GetStarted/partials/Nav.tsx
/* eslint-disable @next/next/no-img-element */ 

var Nav = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "border-b",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " flex items-center justify-between ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#",
                    className: "bg-redblack w-[70px] h-[70px] flex items-center justify-center",
                    "aria-label": "home page",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/imgs/logos/logo.svg",
                        alt: "logo svg image",
                        height: "100%",
                        className: "relative z-[999] w-[4rem]"
                    })
                })
            })
        })
    });
};
/* harmony default export */ var partials_Nav = (Nav);

// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
;// CONCATENATED MODULE: ./src/components/Animation/FadeIn.tsx




var FadeIn = function(param) {
    var children = param.children, element = param.element, vars = param.vars;
    var el = (0,react.useRef)(null);
    var tl = gsap/* gsap.timeline */.p8.timeline({
        defaults: {
            duration: 1
        }
    });
    (0,react.useLayoutEffect)(function() {
        tl.to(".".concat(element), (0,_object_spread/* default */.Z)({
            opacity: 1
        }, vars));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        ref: el,
        children: children
    });
};
/* harmony default export */ var Animation_FadeIn = (FadeIn);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/B-Corp.svg
/* harmony default export */ var B_Corp = ({"src":"/_next/static/media/B-Corp.f0089a35.svg","height":82,"width":49});
// EXTERNAL MODULE: ./node_modules/react-calendly/dist/index.es.js
var index_es = __webpack_require__(20761);
// EXTERNAL MODULE: ./node_modules/react-div-100vh/dist/esm/index.js
var dist_esm = __webpack_require__(66409);
;// CONCATENATED MODULE: ./src/views/GetStarted/partials/MeetingSchedule.tsx



// import useWindowDimensions from '@hooks/useWindowDimensions';
var MeetingSchedule = function() {
    // const {width} :any= useWindowDimensions()
    // const style = {
    //     width: "100%",
    //     height: "1000px",
    //     marginTop: "100px",
    //     "@media (max-width: 1023px)": {
    //         height: "400px !important",
    //     },
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* default */.ZP, {
                className: "flex relative items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* InlineWidget */.KS, {
                    styles: {
                        height: "1000px",
                        width: "100%"
                    },
                    pageSettings: {
                        hideEventTypeDetails: false
                    },
                    url: "https://calendly.com/digitalgregg/30min?hide_gdpr_banner=1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden md:h-28 lg:hidden"
            })
        ]
    });
};
/* harmony default export */ var partials_MeetingSchedule = (MeetingSchedule);

;// CONCATENATED MODULE: ./src/views/GetStarted/partials/SuccessPage.tsx






var SuccessPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation_FadeIn, {
        element: "_getStartedMain",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid lg:grid-cols-2 items-start gap-20 px-5 md:px-20 h-[95%] mt-12 max-w-[1300px] mx-auto opacity-0 _getStartedMain flex-wrap",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex gap-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grow mt-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lg:mt-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: "mb-10 font-bold text-[28px] lg:text-[30px] xl:text-[32px] leading-[48px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-primary",
                                                    children: "Thank you"
                                                }),
                                                " for considering ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Digital Gregg for your project!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[16px] lg:text-[18px] leading-[32px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Please check your email within 24 hours for our response. We look forward to learning about your project."
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "-mb-10 mt-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/insights",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "#",
                                                    "aria-label": "insights page",
                                                    className: "md:text-[13px] text-[12px] before:h-[3rem] font-[600] bg-transparent inline-block explore-hover relative before:absolute before:content-[''] before:left-[-10px] before:right-[-5.71429rem] before:bottom-[0] after:absolute after:content-[''] after:left-[100%] after:top-[calc(50%+4px)] after:h-[2px] after:bg-primary after:w-[40px] mt-5 ",
                                                    children: "Read Our Insights"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-48 sm:mt-32 md:mt-40 w-full lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_MeetingSchedule, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sm:mt-24 md:mt-32 my-14 h-[1px] bg-[#e3e3e3]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-10 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: B_Corp,
                                            alt: "img",
                                            height: "82",
                                            width: "50",
                                            priority: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "max-w-[250px] text-[14px]",
                                            children: "Committed to using business as a force for good."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:block 3xl:mt-8 mt-28 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_MeetingSchedule, {})
                })
            ]
        })
    });
};
/* harmony default export */ var partials_SuccessPage = (SuccessPage);

;// CONCATENATED MODULE: ./src/views/GetStarted/GetStarted.tsx





var GetStarted = function() {
    // states
    var ref = (0,react.useState)(false), getStarted = ref[0], setGetStarted = ref[1];
    var ref1 = (0,react.useState)(false), success = ref1[0], setSuccess = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Nav, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-12",
                    children: !success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Steps, {
                        setSuccess: setSuccess,
                        setGetStarted: setGetStarted
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_SuccessPage, {})
                })
            })
        ]
    });
};
/* harmony default export */ var GetStarted_GetStarted = (GetStarted);

;// CONCATENATED MODULE: ./src/pages/request-estimate.tsx


var RequestEstimatePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetStarted_GetStarted, {})
    });
};
/* harmony default export */ var request_estimate = (RequestEstimatePage);


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5765,3644,9774,2888,179], function() { return __webpack_exec__(47020); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);